import React from 'react';
import proptypes from 'prop-types';
import { Button, Spin } from 'antd';
import './custom-button.scss';
import IconFlag from '@/components/common/icon/iconFlag';

const CustomButton = ({
  children,
  type,
  size,
  className = '',
  onClick,
  block,
  shape,
  disabled,
  fixedIcon,
  icon = null,
  loading,
  flagIcon,
  ...props
}) => (
  <Button
    type={type}
    size={size}
    className={`ant-btn-custom ${fixedIcon ? 'fixed' : ''} ${className}`}
    block={block}
    shape={shape}
    disabled={disabled}
    onClick={onClick}
    {...props}
  >
    {loading && <Spin />}
    <span className="content">{children}</span>
    {icon && <img className="icon" src={icon} alt="icon" />}
    {flagIcon && <IconFlag vector={flagIcon} />}
  </Button>
);

CustomButton.propTypes = {
  children: proptypes.oneOfType([proptypes.object, proptypes.string]),
  type: proptypes.string,
  size: proptypes.string,
  className: proptypes.string,
  onClick: proptypes.func,
  block: proptypes.bool,
  shape: proptypes.string,
  disabled: proptypes.bool,
};
export default CustomButton;
